<template>
  <div>
    <div class="col-12 text-center fs-3 fw-bold my-3">
      Como chegar
    </div>
    <iframe v-if="tipo == 'padrao'" :src="'https://www.google.com/maps/embed?' +
      endereco" width="100%" height="350" style="border:0;" allowfullscreen="" loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe>

    <iframe v-if="tipo == 'satelite'" :src="'https://www.google.com.br/maps?q=' + endereco + '&output=embed'" width="100%" height="350" style="border:0;"
      allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
  </div>
</template>

<script>
export default {
  name: 'Mapa',
  props: {
    endereco: String,
    tipo: {
      default: 'satelite'
    }
  },
  components: {}
}
</script>

<style scoped></style>